/*
 * @author: wayou
 * @date: 2018-12-10 11:17:14
 * @description: AI 报告中转文字及关键词高亮
 */

import React, { Component } from 'react';
import { IElementSetup } from '@umu/umu-types';
import KeyWrodsEmpty from '../@keyWrodsEmpty/keyWrodsEmpty';
import KeyWrodsProcessing from '../@keyWrodsProcessing/keyWrodsProcessing';
import './textHighlightSection.scss';

interface ITextHighlightSectionProps {
    text: string;
    isProcessing: boolean;
    setupInfo?: IElementSetup;
    highlight:string[],
    isPc?:boolean;
}

export default class TextHighlightSection extends Component<ITextHighlightSectionProps, {}> {
    public render() {
        const { text, isProcessing,setupInfo,highlight,isPc } = this.props;
        const { show_ai_keyword_after } = setupInfo || {};
        const highlightedText =this.highlightText(text, (show_ai_keyword_after ==1 || isPc) ? highlight:[]);

        if (isProcessing) {
            return <KeyWrodsProcessing />;
        }

        if (!text) {
            return <KeyWrodsEmpty />;
        }

        return (
            <div className="text-highlight-section">
                <div className="highlight-text-content" dangerouslySetInnerHTML={{ __html: highlightedText }} />
            </div>
        );
    }

    private highlightText(text: string, keywords: string[]) {
        const words = this.getSortedKeywords(keywords);
        if (words.length === 0) {
            return text;
        }
        const patternStr = words.map(word=>word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
        const pattern = new RegExp(patternStr, 'gim');
        return text.replace(pattern, (match) => {
            return `<span class="keyword-highlight" style="color:#F1960D" >${match}</span>`;
        });
    }

    private getSortedKeywords(keywords:string[]) {
        if (!keywords) {
            keywords = [];
        }
        const newWords=[...keywords];
        // NOTE： 如果两个词存在包含关系，比如「中国」，「中国梦」，匹配时谁放前面就匹配谁
        // 始终将较长的字符放前面，
        // 这样生成的正则为 /中国梦|中国/gim
        // 可以保证 「中国梦」在之后的匹配中命中并高亮，否则始终只匹配上 「中国」
        // 因为 js 正则不支持复杂的前向及后向查找，以及贪婪匹配
        newWords.sort((a, b) => {
            return b.length - a.length;
        });

        return newWords;
    }
}
